import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import Preview from '../../itemCard/lockupPreview/preview'
import LockupRating from '../../itemCard/lockupRating'

import * as styles from './itemPreviewCard.module.css'

interface IProps {
  item: IItem
  onClick?: React.EventHandler<any>
}

const ItemPreviewCard = ({ item, onClick = () => {} }: IProps) => {
  const { url, name, author_url, author_username } = item
  return (
    <div className={styles.root}>
      <Preview item={item} onItemLinkClick={onClick} />
      <div className={styles.info}>
        <div className={styles.linkArea}>
          <a href={url} onClick={onClick} className={styles.itemLink}>
            {name}
          </a>
        </div>
        <div className={styles.author}>
          <em> by </em>
          <a className={styles.authorLink} href={author_url.toLowerCase()}>
            {author_username}
          </a>
        </div>
        <div className={styles.rating}>
          <LockupRating item={item} />
        </div>
      </div>
    </div>
  )
}

export default ItemPreviewCard
